export enum TrainingType {
    Atualização = 'Atualização',
    Boleto = 'Boleto',
    Caixa = 'Caixa',
    Cadastro = 'Cadastro',
    Comanda = 'Comanda',
    Condição_De_Pagamento = 'Condição De Pagamento',
    Contas_A_Pagar = 'Contas A Pagar',
    Contas_A_Receber = 'Contas A Receber',
    Duplicata = 'Duplicata',
    Emissão_De_Notas = 'Emissão De Notas',
    Entrada_De_Notas = 'Entrada De Notas',
    Estoque = 'Estoque',
    Farmacia = 'Farmacia',
    Faturamento = 'Faturamento',
    Historico = 'Historico',
    Instalação = 'Instalação',
    Orçamentos = 'Orçamentos',
    OS = 'OS',
    Plano_De_Contas = 'Plano De Contas',
    Posto = 'Posto',
    Pre_Venda = 'Pre Venda',
    Transferencia_De_Banco_ = 'Transferencia De Banco'
}